import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-compact-down', 'ChevronCompactDown', [["path",{"d":"M4 11l8 3l8 -3"}]]);